import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'monkStack - AI & Engineering Solutions',
  description = 'monkStack is a Pune-based AI and engineering studio that builds production SaaS, computer vision, and manufacturing ERP for operators who need software that ships.',
  image = 'https://monkstack.com/img/logo_landing.png',
  url = 'https://monkstack.com',
  type = 'website',
  structuredData = null,
  noindex = false
}) => {
  const fullTitle = title.includes('monkStack') ? title : `${title} | monkStack`;
  const siteName = 'monkStack';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {/* Uncomment and update when Twitter handles are available */}
      {/* <meta name="twitter:site" content="@monkstack" /> */}
      {/* <meta name="twitter:creator" content="@monkstack" /> */}

      {/* Canonical URL */}
      <link rel="canonical" href={url} />

      {/* Structured Data */}
      {structuredData && (
        Array.isArray(structuredData) ? (
          structuredData.map((schema, index) => (
            <script key={index} type="application/ld+json">
              {JSON.stringify(schema)}
            </script>
          ))
        ) : (
          <script type="application/ld+json">
            {JSON.stringify(structuredData)}
          </script>
        )
      )}
    </Helmet>
  );
};

export default SEO;

